import React, { useRef } from "react";
import "./placeDetails.css";

import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import motorcycle from "../../images/icons/motorcycle.png";

import { Link } from "react-router-dom";
import MotorLicense from "./MotorLicense";

import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";

import { useShipping } from "../../contexts/ShippingContext";

export default function InMotorcycleDetail() {
  const navigate = useNavigate();

  const idTopThreeDigitsRef = useRef();
  const idBottomFiveDigitsRef = useRef();
  //   const bikeModelRef = useRef();
  //   const bikeColorRef = useRef();

  const { addDeliveryInfo } = useShipping();

  function handleSubmit(e) {
    e.preventDefault();

    const idTopThreeDigits = idTopThreeDigitsRef.current.value;
    const idBottomFiveDigits = idBottomFiveDigitsRef.current.value;
    // const bikeModel = bikeModelRef.current.value;
    // const bikeColor = bikeColorRef.current.value;

    if (!idTopThreeDigits || !idBottomFiveDigits) {
      return toast.error("لطفا اطلاعات را وارد کنید");
    }

    if (isNaN(idTopThreeDigits) || isNaN(idBottomFiveDigits)) {
      return toast.error("لطفا شماره پلاک صحیح را وارد کنید");
    }

    addDeliveryInfo("BYCE", {
      id_top_three_digits: idTopThreeDigits,
      id_bottom_five_digits: idBottomFiveDigits,
    });
    navigate("/shipping/location");
  }

  return (
    <div className="detail-main-container">
      <div className="place-detail-text">
        <h2 className="middle-box-header">من اینجا..</h2>
        <div className="place-item detail-item">
          <span className="place-item-icon">
            <img src={motorcycle} alt="" className="detail-motorcycle" />
          </span>
          با موتور هستم
        </div>
        <Link to="/shipping/type" className="detail-return-link">
          <span className="return-text detail-return-text">
            بازگشت
            <FontAwesomeIcon icon={faChevronLeft} className="return-icon" />
          </span>
        </Link>
      </div>
      <div className="detail-information">
        <form action="" className="detail-info-form" onSubmit={handleSubmit}>
          <MotorLicense
            ref={{
              idTopThreeDigitsRef: idTopThreeDigitsRef,
              idBottomFiveDigitsRef: idBottomFiveDigitsRef,
            }}
          />
          {/* <InputBox gap="15px" label="مدل" ref={bikeModelRef} />
            <InputBox gap="30px" label="رنگ" ref={bikeColorRef} /> */}
          <button className="red-submit-btn detail-submit-btn">ثبت</button>
        </form>
      </div>
    </div>
  );
}
